import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { MdDashboard } from 'react-icons/md'
import {useLocation} from 'react-router-dom';
import FormField from './FormField';
import { useDispatch, useSelector } from 'react-redux';
import { selectOptions, setDomain, setSubdomain, unsetSubdomain, unsetTopic } from '../../features/optionSlice';
import { useGetDomainsMutation, useGetSubdomainsMutation } from '../../features/apiSlice';
import { fetchDomains, fetchSubdomains } from '../../utils/apis';

function DomainHeader() {

  const location = useLocation()
  const isAos = location.pathname.includes('all-specialties');

 const dispatch = useDispatch();

  const {domain,subdomain} = useSelector(selectOptions);
  const [getSubdomains,{isLoading:subdomainLoading} ] = useGetSubdomainsMutation();
  const [domains,setDomains] = useState([]);
  const [subdomains,setSubdomains] = useState([]);
  // const [selectedDomain,setSelectedDomain] = useState(null)
  const [getDomains,{isLoading:domainLoading} ] = useGetDomainsMutation();

  useEffect(()=>{
    // setSubdomains([])
    if(domains?.length>0 && !domain){
       dispatch(setDomain(domains[0]?._id));
    }

 },[domains,domain])


  useEffect(()=>{
    // setSubdomains([])
    if(subdomains?.length>0){
    if( !subdomains?.some(sub => sub?._id === subdomain)){
       dispatch(setSubdomain(subdomains[0]?._id));
    }
  }

 },[subdomains])

 useEffect(()=>{
  fetchDomains({getDomains,setDomains});
},[])

 useEffect(()=>{
  if(domain  ){

      fetchSubdomains({getSubdomains,setSubdomains,id:domain});
  }
},[domain])





  return (
    
    <Col className='px-1'>
    <Row className=' rounded-3 ' style={{border:'2px solid var(--primary-color)'}}>
<Col sm={6} className=''>
<div className=' d-flex align-items-center'>
               <div className='me-1'> 
               <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_6576_17346)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M6.375 0H2.5C1.83696 0 1.20107 0.263392 0.732233 0.732233C0.263392 1.20107 0 1.83696 0 2.5L0 6.375H6.375V0ZM0 11.5V7.625H6.375V14H2.5C1.83696 14 1.20107 13.7366 0.732233 13.2678C0.263392 12.7989 0 12.163 0 11.5ZM7.625 14V7.625H14V11.5C14 12.163 13.7366 12.7989 13.2678 13.2678C12.7989 13.7366 12.163 14 11.5 14H7.625ZM14 2.5V6.375H7.625V0H11.5C12.163 0 12.7989 0.263392 13.2678 0.732233C13.7366 1.20107 14 1.83696 14 2.5ZM2.033 2.725C1.86724 2.725 1.70827 2.79085 1.59106 2.90806C1.47385 3.02527 1.408 3.18424 1.408 3.35C1.408 3.51576 1.47385 3.67473 1.59106 3.79194C1.70827 3.90915 1.86724 3.975 2.033 3.975H2.658V4.6C2.658 4.76576 2.72385 4.92473 2.84106 5.04194C2.95827 5.15915 3.11724 5.225 3.283 5.225C3.44876 5.225 3.60773 5.15915 3.72494 5.04194C3.84215 4.92473 3.908 4.76576 3.908 4.6V3.975H4.533C4.69876 3.975 4.85773 3.90915 4.97494 3.79194C5.09215 3.67473 5.158 3.51576 5.158 3.35C5.158 3.18424 5.09215 3.02527 4.97494 2.90806C4.85773 2.79085 4.69876 2.725 4.533 2.725H3.908V2.1C3.908 1.93424 3.84215 1.77527 3.72494 1.65806C3.60773 1.54085 3.44876 1.475 3.283 1.475C3.11724 1.475 2.95827 1.54085 2.84106 1.65806C2.72385 1.77527 2.658 1.93424 2.658 2.1V2.725H2.033ZM9.025 3.35C9.025 3.004 9.305 2.725 9.65 2.725H11.65C11.8158 2.725 11.9747 2.79085 12.0919 2.90806C12.2092 3.02527 12.275 3.18424 12.275 3.35C12.275 3.51576 12.2092 3.67473 12.0919 3.79194C11.9747 3.90915 11.8158 3.975 11.65 3.975H9.65C9.48424 3.975 9.32527 3.90915 9.20806 3.79194C9.09085 3.67473 9.025 3.51576 9.025 3.35ZM9.65 9.032C9.48424 9.032 9.32527 9.09785 9.20806 9.21506C9.09085 9.33227 9.025 9.49124 9.025 9.657C9.025 9.82276 9.09085 9.98173 9.20806 10.0989C9.32527 10.2162 9.48424 10.282 9.65 10.282H11.65C11.8158 10.282 11.9747 10.2162 12.0919 10.0989C12.2092 9.98173 12.275 9.82276 12.275 9.657C12.275 9.49124 12.2092 9.33227 12.0919 9.21506C11.9747 9.09785 11.8158 9.032 11.65 9.032H9.65ZM9.025 11.657C9.025 11.312 9.305 11.032 9.65 11.032H11.65C11.8158 11.032 11.9747 11.0978 12.0919 11.2151C12.2092 11.3323 12.275 11.4912 12.275 11.657C12.275 11.8228 12.2092 11.9817 12.0919 12.0989C11.9747 12.2162 11.8158 12.282 11.65 12.282H9.65C9.56792 12.282 9.48665 12.2658 9.41082 12.2344C9.33499 12.203 9.2661 12.157 9.20806 12.0989C9.15002 12.0409 9.10398 11.972 9.07258 11.8962C9.04117 11.8203 9.025 11.7391 9.025 11.657ZM1.781 9.215C1.83904 9.15695 1.90795 9.11089 1.98378 9.07947C2.05962 9.04805 2.14091 9.03188 2.223 9.03188C2.30509 9.03188 2.38638 9.04805 2.46222 9.07947C2.53805 9.11089 2.60696 9.15695 2.665 9.215L3.283 9.833L3.901 9.215C4.01823 9.09777 4.17722 9.03192 4.343 9.03192C4.50878 9.03192 4.66777 9.09777 4.785 9.215C4.90223 9.33223 4.96808 9.49122 4.96808 9.657C4.96808 9.82278 4.90223 9.98177 4.785 10.099L4.167 10.717L4.785 11.335C4.84304 11.393 4.88909 11.462 4.9205 11.5378C4.95191 11.6136 4.96808 11.6949 4.96808 11.777C4.96808 11.8591 4.95191 11.9404 4.9205 12.0162C4.88909 12.092 4.84304 12.161 4.785 12.219C4.72696 12.277 4.65805 12.3231 4.58221 12.3545C4.50637 12.3859 4.42509 12.4021 4.343 12.4021C4.26091 12.4021 4.17963 12.3859 4.10379 12.3545C4.02795 12.3231 3.95904 12.277 3.901 12.219L3.283 11.601L2.665 12.219C2.60696 12.277 2.53805 12.3231 2.46221 12.3545C2.38637 12.3859 2.30509 12.4021 2.223 12.4021C2.14091 12.4021 2.05963 12.3859 1.98379 12.3545C1.90795 12.3231 1.83904 12.277 1.781 12.219C1.72296 12.161 1.67691 12.092 1.6455 12.0162C1.61409 11.9404 1.59792 11.8591 1.59792 11.777C1.59792 11.6949 1.61409 11.6136 1.6455 11.5378C1.67691 11.462 1.72296 11.393 1.781 11.335L2.399 10.717L1.781 10.099C1.72295 10.041 1.67689 9.97205 1.64547 9.89622C1.61406 9.82038 1.59788 9.73909 1.59788 9.657C1.59788 9.57491 1.61406 9.49362 1.64547 9.41778C1.67689 9.34195 1.72295 9.27304 1.781 9.215Z" fill="#00008B"/>
</g>
<defs>
<clipPath id="clip0_6576_17346">
<rect width="14" height="14" fill="white"/>
</clipPath>
</defs>
</svg>
                
                </div>
               
               <div className='w-75'> 
               <FormField
              className={'mt-3'}
              type={"select"}
              name={'domain'}
              value={domain}
              onChange={(e)=>{

                dispatch(unsetSubdomain())
                dispatch(setDomain(e.target.value))



              }}
             
              options={domains && domains?.map((domain) => ({
                label: domain?.domain_name,
                value: domain?._id,
            }))}

            />
            </div>
            </div>
</Col>
<Col>
{isAos ? null : 
                
              <div className='d-flex align-items-center justify-content-center'>
           <div className='pe-1'>Speciality:</div>
              
            
           <div className='w-75'> 

           <FormField
             className={'mt-3'}
             type={"select"}
             name={'subdomain'}
             value={subdomain}
             onChange={(e)=>{
              
              dispatch(unsetTopic());
              dispatch(setSubdomain(e.target.value))
            
            
            }} 
            
             options={subdomains && subdomains?.map((subdomain) => ({
               label: subdomain?.sub_domain_name,
               value: subdomain?._id,
           }))}

           />
           </div>
           </div>
             
            
          
          
           }
</Col>



      
    </Row>
    </Col>
    
   
    
  )
}

export default DomainHeader